import image from "./masaischool.png";
export const projects = [
  {
    img: "https://i.ibb.co/h2kd8WX/ankitblogs.png",
    title: "Ankit Blogs",
    des: "A project focusing on a responsive blogging website with key features including authentication, admin panel, search functionality,code editor plugins, advanced search, protected routes, and a comment  section",
    demo: "",
    live: "https://meek-manatee-2b5155.netlify.app/",
    gitHub: "https://github.com/Ankitkumar-tech/Bloging_Website-",
    technologies: [
      "React",
      "Context API",
      "Firebase",
      "Tailwind CSS",
      "Material UI",
    ],
  },
  {
    img: image,
    title: "Onwards",
    des: "Built during a hackathon with a 5-person team, Onwards streamlines the admission process by assessing users, suggesting courses based onperformance, and facilitating onboarding.",
    demo: "",
    live: "https://masaionwards.vercel.app/login",
    gitHub: "https://github.com/Ankitkumar-tech/Onwards",
    technologies: [
      "Node.js",
      "Express",
      "MongoDB",
      "Mongoose",
      "Nodemailer",
      "Twilio",
      "React",
      "Chakra-UI",
    ],
  },

  {
    img: "https://i.ibb.co/QcWm4JS/Screenshot-2022-03-15-015410-2.png",
    title: "Hometogo Clone",
    des: "Hometogo is basically web application where user can book rooms ,villa and apartment as well",
    demo: "",
    live: "https://home2go-frontend-api.vercel.app/",
    gitHub: "https://github.com/Ankitkumar-tech/Hometogo",
    technologies: ["JavaScript,", "HTML,", "CSS,", "mongogb"],
  },
  {
    img: "https://i.ibb.co/chch7pg/Screenshot-2022-03-15-003420-2.png",
    title: "TikTacToe",
    des: "This is a tictaktoe game. User can play this game with their friend",
    demo: "",
    live: "https://phlansha.vercel.app/",
    gitHub: "https://github.com/Ankitkumar-tech/tictaktoe",
    technologies: ["JavaScript,", "HTML,", "CSS"],
  },
  {
    img: "https://i.ibb.co/GpXhTHD/Screenshot-2022-03-15-233734.png",
    title: "A weather app",
    des: "A weather app where use can search their city weather and also it show the map of the user city also ",
    demo: "",
    live: "https://ankit-bestwork.vercel.app/",
    gitHub: "https://github.com/Ankitkumar-tech/Weatherapp",
    technologies: ["HTML,", "CSS,", "javascript"],
  },
  // {
  // 	img: 'https://camo.githubusercontent.com/b7f4aa8c34ddf776dd19b78dc3488456470a73e5026f48784e9e753601468802/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f4c62507030307771454537386c6f68584d372f67697068792e676966',
  // 	title: 'Clone of Fitness Blender',
  // 	des: 'This is a clone of the Fitness Blender website. The clone is complete with a Login page, Sign-in page, Shopping Cart, Wishlist and Calendar Scheduling feature. Following is the link to the clone of the website.',
  // 	demo: '',
  // 	live: 'https://anshusagar.github.io/FitnessBlender/',
  // 	gitHub: 'https://github.com/Anshusagar/FitnessBlender.git',
  // 	technologies: ['HTML', 'CSS', 'javaScript'],
  // },
  // {
  // 	img: 'https://github.com/mandarsatam/Mailchimp-Clone/blob/master/Snips/Screenshot%20(79).png?raw=true',
  // 	title: 'Mailchimp Clone',
  // 	des: 'This is a static clone of a website called Mailchimp. This clone includes landing, pricing, our story, and the resources page.',
  // 	demo: '',
  // 	live: 'https://mandarsatam.github.io/Mailchimp-Clone/',
  // 	gitHub: 'https://github.com/mandarsatam/Mailchimp-Clone',
  // 	technologies: ['HTML', 'CSS', 'javaScript'],
  // },
  {
    img: "https://i.ibb.co/480gx1x/Screenshot-2022-03-23-145736.png",
    title: "Clone of Walmart.com ",
    des: "Walmart is a web application where user can buy product",
    demo: "",
    live: "", // deployed link
    gitHub: "https://github.com/Aakashvani/Walmart-Clone-Unit2-",
    technologies: ["HTML,", "CSS,", "javaScript,"],
  },
];
